<!-- 产品管理列表 -->
<template>
    <div>
        <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane label="国家公告配置" name="product">
              <countryNotice></countryNotice>
            </el-tab-pane>
            <el-tab-pane label="攻略及业务介绍配置" name="country">
              <countryGuide></countryGuide>
            </el-tab-pane>
            <el-tab-pane label="国家排序" name="sort">
              <countrySort></countrySort>
            </el-tab-pane>
        </el-tabs>
    </div>

</template>

<script>
import countryNotice from './countryNotice.vue'
import countryGuide from './countryGuide.vue'
import countrySort from './countrySort.vue'

export default {
    components: {
        countryNotice,
        countryGuide,
        countrySort
    },
    data() {
        return {
            activeName: 'product',

        }
    },
}
</script>

<style lang="scss" scoped>
.product-user {
    // min-width: 973px;
    // width: 100%;
    height: 100%;

    ::v-deep {
        .el-select {
            margin-right: 8px;
        }

        .el-input__inner {
            background: #F2F4F7;
            border: none;
        }

        .el-table__row {
            .cell {
                font-size: 12px;
            }
        }
    }
}

.box-input-left {
    display: flex;

}
::v-deep {
    .el-tabs {
      height: 100%;

      .el-tabs__content {
        height: calc(100% - 60px) !important;
        overflow: auto;
      }
    }

    .el-tab-pane {
      height: 100%;

      >div {
        height: calc(100% - 0px) !important;
      }
    }
  }

.box-table {
    // flex-grow: 1;
    // height: 100%;
    // display: flex;
    // flex-direction: column;
    // flex: 1;
}

.edit-wrap {

    .edit-item {
        // padding-left: 20px;


        span {
            cursor: pointer;
            display: inline-block;
            margin: 6px;

            &.lan {
                color: #3888E9;
            }

            &.copy {
                color: #9EA09E;
            }

            &.del {
                color: #E41313;
            }
        }
    }
}

.table-pagination {
    text-align: center;
    margin-top: 16px;
}

.box-input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    width: 100%;

    .box-input-btn {
        text-align: right;

        .box-input-btn-cz {
            background: #EAF3FF;
            color: #3888E9;
            border: none;
        }

        .box-input-btn-add {
            background: #D8F5E4;
            color: #54D8A5;
            border: none;
        }
    }
}
</style>